<template>
	<div class="page-mdl gray-bg">

		<!-- 广告幻灯片 -->
		<section class="banner-slide">
			<div class="swiper-container" id="bannerSlide">
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-for="item in bannerList">
						<a href="javascript:;"><img :src="item.value" alt=""></a>
					</div>
				</div>
				<div class="swiper-pagination" slot="pagination"></div>
				<div class="prev"><img src="../../assets/img/prev.png" alt=""></div>
				<div class="next"><img src="../../assets/img/next.png" alt=""></div>
			</div>
		</section>

		<!-- 大赛动态 -->
		<div class="dsdt-mdl">
			<div class="w1440" v-if="dsdtData">
				<div class="index-title">
					<img src="../../assets/img/tit-dsdt.png" alt="">
					<a href="javascript:;" class="more-btn"
						@click="goUrl({ name:'pageList', params:{ catid:dsdtData.catid}})">>> more</a>
				</div>
				<ul class="dsdt-list">
					<li v-for="(item,index) in dsdtData.list" :key="item.id"
						@click="goUrl({ name:'pageDetail', params:{ id:item.id}})" v-show="index<=1">
						<img class="img" :src="item.thumb" alt="">
						<div class="info">
							<h3>{{item.title}}</h3>
							<div class="date">{{item.inputtime}}</div>
						</div>
					</li>
				</ul>
				<ul class="news-list" v-if="dsdtData.list.length>2">
					<li v-for="(item,index) in dsdtData.list" :key="item.id"
						@click="goUrl({ name:'pageDetail', params:{ id:item.id}})" v-show="index>1">
						<span class="date">{{item.inputtime}}</span>
						<i class="dot"></i>
						<p>{{item.title}}</p>
					</li>
				</ul>
			</div>
		</div>
		

		<!-- 大赛相关 -->
		<div class="dsxg-mdl">
			<div class="w1440">
				<div class="index-title">
					<img src="../../assets/img/tit-dsxg.png" alt="">
				</div>
				<div class="dsxg-list">
					<div class="item" v-for="(item,index) in dsxgData.childCategory" :key="item.catid">
						<ul class="list" v-if="item.child.length==0">
							<li>
								<div class="head">
									<!-- <a v-if="item.tid==0" href="javascript:;" class="more" @click="goUrl({ name:'pageDetail2', query:{ catid:item.catid}})">>> more</a>
									<a v-if="item.tid==1" href="javascript:;" class="more" @click="goUrl({ name:'pageList', params:{ catid:item.catid}})">>> more</a> -->
									<h3><img class="ico" :src="item.thumb" alt="">{{item.catename}}</h3>
								</div>
								<div v-if="item.list.length==0" class="ctn" v-html="item.content"></div>
								<div v-if="item.list.length>0" class="y-btns">
									<a target="_blank" :href="item2.attached" v-for="(item2,index2) in item.list"
										:key="item2.id">{{item2.title}}</a>
								</div>
							</li>
						</ul>
						<ul class="list" v-if="item.child.length>0">
							<li v-for="(item2,index2) in item.child" :key="item2.catid">
								<div class="head">
									<!-- <a href="javascript:;" class="more">>> more</a> -->
									<h3><img class="ico" :src="item2.thumb" alt="">{{item2.catename}}</h3>
								</div>
								<div class="ctn" v-html="item2.content"></div>
							</li>
						</ul>
					</div>
					<!-- <div class="item">
						<ul class="list">
							<li>
								<div class="head">
									<a href="javascript:;" class="more">>> more</a>
									<h3><img class="ico" src="../../assets/img/dsxg-ico01.png" alt="">大赛组委会</h3>
								</div>
								<p>国家开放大学设立大赛组织委员会（简称国开大赛组委会），由国家开放大学党委书记、校长荆德刚担任主任，副书记刘臣、副校长亓彦伟担任副主任，有关部门负责人作为成员，负责决定大赛重要事项。</p>
								<p>国家开放大学设立大赛组织委员会（简称国开大赛组委会），由国家开放大学党委书记、校长荆德刚担任主任，副书记刘臣、副校长亓彦伟担任副主任，有关部门负责人作为成员，负责决定大赛重要事项。</p>
							</li>
						</ul>
					</div>
					<div class="item">
						<ul class="list">
							<li>
								<div class="head">
									<a href="javascript:;" class="more">>> more</a>
									<h3><img class="ico" src="../../assets/img/dsxg-ico01.png" alt="">大赛组委会</h3>
								</div>
								<p>国家开放大学设立大赛组织委员会（简称国开大赛组委会），由国家开放大学党委书记、校长荆德刚担任主任，副书记刘臣、副校长亓彦伟担任副主任，有关部门负责人作为成员，负责决定大赛重要事项。</p>
							</li>
							<li>
								<div class="head">
									<a href="javascript:;" class="more">>> more</a>
									<h3><img class="ico" src="../../assets/img/dsxg-ico01.png" alt="">大赛组委会</h3>
								</div>
								<p>国家开放大学设立大赛组织委员会（简称国开大赛组委会），由国家开放大学党委书记、校长荆德刚担任主任，副书记刘臣、副校长亓彦伟担任副主任，有关部门负责人作为成员，负责决定大赛重要事项。</p>
							</li>
						</ul>
					</div>
					<div class="item">
						<ul class="list">
							<li>
								<div class="head">
									<a href="javascript:;" class="more">>> more</a>
									<h3><img class="ico" src="../../assets/img/dsxg-ico01.png" alt="">大赛组委会</h3>
								</div>
								<div class="y-btns">
									<a href="javascript:;">大学生手册</a>
									<a href="javascript:;">省级校级操作手册</a>
									<a href="javascript:;">大赛通知</a>
								</div>
							</li>
						</ul>
					</div>
				 -->
				</div>
			</div>
		</div>

		<!-- 大赛历程 -->
		<div class="dslc-mdl">
			<div class="index-title">
				<img src="../../assets/img/tit-dslc.png" alt="">
			</div>
			<div class="dslc-ctn">
				<img v-if="dslcData" class="img" :src="dslcData.thumb" alt="">
			</div>
		</div>

		<!-- 培训资源 -->
		<div class="pxzy-mdl">
			<div class="index-title">
				<img src="../../assets/img/tit-pxzy.png" alt="">
				<a href="javascript:;" class="more-btn"
					@click="goUrl({ name:'pageList', params:{ catid:pxzyData.catid}})">>> more</a>
			</div>
			<div class="pxzy-ctn">
				<div class="pxzy-item" v-for="(item,index) in pxzyData.list">
					<video class="video" controls :src="item.video"></video>
					<a href="javascript:;" class="btn text-elli"
						@click="goUrl({ name:'pageDetail', params:{ id:item.id}})">{{item.title}}</a>
				</div>

				<!-- <div class="pxzy-item">
					<video class="video" controls src="http://oss.ouchn.cn/zongbu/双创网站/081105.mp4"></video>
					<a href="javascript:;" class="btn text-elli">【第06讲】第6届中国国际“互联网+”大学生创新创业大...</a>
				</div> -->
			</div>
		</div>

	</div>
</template>

<script>
	import configMixin from '@/mixins/index.js'
	import pageMixin from '@/mixins/page.js'
	import Swiper from 'swiper';
	import 'swiper/dist/css/swiper.css';
	export default {
		mixins: [configMixin, pageMixin],
		name: 'pageIndex',
		data() {
			return {
				bannerList: [],

				dsdtData: null, //大赛动态
				dsxgData: [], //大赛相关
				dslcData: null, //大赛历程
				pxzyData: [], //培训资源

			}
		},

		created() {

		},

		computed: {

		},

		mounted() {
			this.reachPage()

		},

		methods: {

			reachPage() {
				//顶部广告轮播图
				this.getBanner('topBanner', 10).then((list) => {
					this.bannerList = list
					setTimeout(() => {
						this.bannerSwiper()
					}, 3000)
				})
				this.getDsdtData()
				this.getDsxgData()
				this.getPxzyData()
				this.getDslcData()

			},

			//顶部广告幻灯片
			bannerSwiper() {
				//低版本幻灯片
				this.bannerSlide = new Swiper('#bannerSlide', {
					loop: true,
					slidesPerView: 1,
					prevButton: '.prev',
					nextButton: '.next',
					pagination: '.swiper-pagination',
					paginationClickable: true,
					autoplay: 3000,
				})
			},


			//获取大赛动态
			getDsdtData() {
				this.$axios({
					url: '/index.php?s=common&c=api&m=dynamicCategory',
					success: (res) => {
						this.dsdtData = res.data
					}
				})
			},

			//获取大赛相关
			getDsxgData() {
				this.$axios({
					url: '/index.php?s=common&c=api&m=getRelevantCategory',
					success: (res) => {
						this.dsxgData = res.data
					}
				})
			},

			//获取大赛历程
			getDslcData() {
				this.$axios({
					url: '/index.php?s=common&c=api&m=getCourseCategory',
					success: (res) => {
						this.dslcData = res.data
					}
				})
			},

			//获取培训资源
			getPxzyData() {
				this.$axios({
					url: '/index.php?s=common&c=api&m=getTrainCategory',
					success: (res) => {
						this.pxzyData = res.data
					}
				})
			},


			//更多跳转
			moreGo(catid) {
				this.goUrl({
					name: 'pageList',
					params: {
						catid: catid
					}
				})
				// if(!item.more){
				// 	this.goUrl({ name:'pageList', params:{ catid:item.catid}})
				// }else{
				// 	this.goUrlOut(item.more)
				// }
			},

			//跳转详情
			goDetail(id) {
				this.goUrl({
					name: 'pageDetail',
					params: {
						id: id
					}
				})
			},
		}
	}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.gray-bg{background:#eee; }

/* 广告幻灯片 */
.banner-slide{
	width:100%;  margin:0 auto 0; overflow: hidden; font-size:0; line-height:0;
	a{width:100%;  display:block; cursor: default;
		img{width:100%; }
	}
	.prev,.next{padding: 25px 15px ; position: absolute; top: 50%; margin-top: -53px; background: rgba(0,0,0,.5); z-index: 10; cursor: pointer;}
	.prev{ left:0; border-radius:0 5px 5px 0;}
	.next{right:0;  border-radius:5px 0 0 5px;}
	.prev:hover,.next:hover{background:  rgba(0,0,0,.9); }
	.swiper-pagination{bottom:20px;}
	.swiper-pagination .swiper-pagination-bullet{ width:20px; height: 20px; background:#fff; opacity:.8; margin:0 7px;}
	.swiper-pagination .swiper-pagination-bullet-active{background:#007aff; opacity:1; }
	
}

.index-title{
	text-align: center; position:relative; height:52px; margin-bottom:30px;
	img{height:52px; display:inline-block; }
	.more-btn{font-size: 14px;  color: #000; position:absolute; right:35px; top:0; line-height:52px;}
	.more-btn:hover{color:#ff0000;}
}

.dsdt-mdl{
	.w1440{background:#fff; padding:30px 0 50px;}
	.dsdt-list{
		display:flex; flex-wrap:wrap; padding: 0 50px; justify-content: space-between; margin-bottom:-50px;
		li{
			width:614px; height:183px; background:url('../../assets/img/dsdt-li-bg.png') no-repeat; box-sizing: border-box; padding-top:13px; margin-bottom:50px; cursor: pointer;
			.img{width:228px; height:160px; float:left; margin-right:20px;}
			.info{
				overflow:hidden; padding-top:15px; position:relative; height:183px; box-sizing: border-box; padding-right:30px;
				h3{ font-size: 20px; color: #333; line-height: 28px; max-height: 84px; display: -webkit-box; -webkit-box-orient: vertical; overflow: hidden; -webkit-line-clamp: 3;}
				.date{ font-size:16px; color:#666; line-height:24px; position:absolute; left:0; bottom:30px; }
			}
		}
		li:hover{
			.info h3{ color: #FF0000; }
		}
	}
	.news-list{
		padding:30px 70px 0; 
		li{ 
			height:46px; line-height:46px; overflow:hidden; border-bottom:1px dotted #999;
			.date{font-size:14px; color:#999; line-height:46px; float:right; }
			.dot{ float:left; width:10px; height:10px; background:#3399ff; margin-top:20px; margin-right:15px; }
			p{font-size:16px; color:#666; line-height:46px;display: block; text-overflow:ellipsis; white-space:nowrap; overflow:hidden; cursor: pointer;
				&:hover{color:#e83d27;}
			}
			&:last-child{border-bottom:none;}
		}
	}
}

// 大赛相关
.dsxg-mdl{
	 background:url('../../assets/img/dsxg-bg.jpg') no-repeat center center; background-size:cover;  padding:30px 0 50px;
	 .dsxg-list{
		 display:flex; flex-wrap: wrap; margin:0 50px; border:1px solid #fff; 
		 .item{
			 width:50%; border-right:1px solid #fff; border-top:1px solid #fff; box-sizing: border-box; padding:20px 40px 40px 20px; color:#fff;
			 .list{
				 li{
					 margin-bottom:30px;
					 .head{
						 overflow:hidden; margin-bottom:10px;
						 h3{
							 font-size: 26px; line-height:50px;
							 .ico{ display:inline-block; width:59px; height:50px; vertical-align: top; margin-right:15px;}
						 }
						 .more{float:right; line-height: 50px; color:#000; font-size:14px;}
						 .more:hover{ color:#ff0000; text-decoration: underline;}
					 }
					 .ctn{  font-size:18px; line-height:28px; padding-left:75px; text-align: justify;}
					 &:last-child{margin-bottom:0;}
				 }
			 }
			 .y-btns{
				padding-left:75px; padding-top:20px;
				a{ 
					display:inline-flex; width:245px; height:65px;  margin-right:30px; justify-content: center; align-items: center; font-size:20px; color:#333; font-weight:bold;
					background:url('../../assets/img/y-btn-bg.png') no-repeat center center; background-size:cover; margin-bottom:20px;
					&:nth-child(2n){margin-right:0;}
					&:hover{color:#ff0000;}
				}
			 }
		 }
		 .item:nth-child(1),.item:nth-child(2){border-top:none; }
		 .item:nth-child(2n){border-right:none;}
	 }
}

//大赛历程
.dslc-mdl{
	background:url('../../assets/img/jxsz-bg.gif') repeat;  padding:30px 0 50px;
	.dslc-ctn{
		text-align: center;
		img{max-width:100%;}
	}
}

// 培训资源
.pxzy-mdl{
	background:url('../../assets/img/pxzy-bg.jpg') no-repeat; background-size:100% 100%; padding:30px 0 50px;
	.pxzy-ctn{ 
		width:1380px; margin:0 auto; border:1px solid #fff;  padding:30px 0; display:flex;
		.pxzy-item{
			width:50%; box-sizing: border-box; padding:30px 64px 0;
			&:first-child{border-right:2px solid #fff;}
			.video{width:560px; height:418px; background:#333;}
			.btn{display:block; height:64px; line-height:64px; background:url('../../assets/img/pxzy-btn.png') no-repeat center center; background-size:100% 100%; box-sizing: border-box; padding:0 20px;  margin-top:10px; font-size:20px; color:#fff;}
			.btn:hover{color:#ff0000;}
		}
	}
}

</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue